// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile {
  display: none;
}
@media screen and (max-width: 1000px) {
  .mobile {
    display: block;
    position: fixed;
    top: 20px;
    right: 40px;
  }
  .desktop {
    display: none !important;
  }
}
.collapsible-content {
  background: #ffffff;
  cursor: pointer;
  color: #7F6C2E;
  border: 1px solid #d4cfbe;
}
.collapsible-content > p {
  font-size: 20px;
  margin: 10px 10px;
}
.collapsible-heading {
  padding: 4px 8px;
  margin-left: 18px;
}
.collapsible-heading > p {
  margin: 0px;
}
.lang-toggle {
  color: #5e5e5e;
}
.lang-toggle-block {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: absolute;
  color: #cccccc;
  right: 0;
  top: 40px;
  right: 40px;
  z-index: 3;
}
.lang-toggle-block .desktop {
  height: 5rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.lang-label {
  display: flex;
  flex-direction: column;
}
.lang-label > .lang-choice {
  background-color: transparent;
  border: none;
}
.lang-label > .lang-choice > p {
  color: #5e5e5e;
  font-size: 18px;
  text-transform: uppercase;
  margin-bottom: 3px;
}
.lang-label > .lang-choice:hover > p {
  color: #b39841;
}
.lang-label > .lang-choice.active > p {
  color: #b39841;
  text-decoration: underline;
}
.lang-mobile-active {
  color: #b39841;
  font-size: 18px;
  font-weight: bold;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/language-toggle/language-toggle.component.less"],"names":[],"mappings":"AAEA;EACE,aAAA;AADF;AAKA;EACE;IACE,cAAA;IACA,eAAA;IACA,SAAA;IACA,WAAA;EAHF;EAMA;IACE,wBAAA;EAJF;AACF;AAOA;EACE,mBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AALF;AACA;EAOI,eAAA;EACA,iBAAA;AALJ;AASA;EACE,gBAAA;EACA,iBAAA;AAPF;AAKA;EAKI,WAAA;AAPJ;AAaE;EACE,cAAA;AAXJ;AAaI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAXN;AAEI;EAYI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAXR;AAgBE;EACE,aAAA;EACA,sBAAA;AAdJ;AAYE;EAII,6BAAA;EACA,YAAA;AAbN;AAQE;EAQM,cAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AAbR;AAgBM;EACE,cAAA;AAdR;AAiBM;EACE,cAAA;EACA,0BAAA;AAfR;AAoBE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AAlBJ","sourcesContent":["@import (reference) \"../../../../../node_modules/proceduralsystem-clientcomponents/styles/variables.less\";\n\n.mobile {\n  display: none;\n}\n\n\n@media screen and (max-width: 1000px) {\n  .mobile {\n    display: block;\n    position: fixed;\n    top: 20px;\n    right: 40px;\n  }\n\n  .desktop {\n    display: none !important;\n  }\n}\n\n.collapsible-content {\n  background: @white;\n  cursor: pointer;\n  color: @primary-base;\n  border: 1px solid @primary-50;\n\n  > p {\n    font-size: 20px;\n    margin: 10px 10px;\n  }\n}\n\n.collapsible-heading {\n  padding: 4px 8px;\n  margin-left: 18px;\n\n  > p {\n    margin: 0px;\n  }\n\n}\n\n.lang {\n  &-toggle {\n    color: @secondary-80;\n\n    &-block {\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n      position: absolute;\n      color: @secondary-30;\n      right: 0;\n      top: 40px;\n      right: 40px;\n      z-index: 3;\n\n      .desktop {\n        height: 5rem;\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-end;\n      }\n    }\n  }\n\n  &-label {\n    display: flex;\n    flex-direction: column;\n    > .lang-choice {\n      background-color: transparent;\n      border: none;\n\n      > p {\n        color: @secondary-80;\n        font-size: 18px;\n        text-transform: uppercase;\n        margin-bottom: 3px;\n      }\n\n      &:hover > p {\n        color: @primary-90;\n      }\n\n      &.active > p {\n        color: @primary-90;\n        text-decoration: underline;\n      }\n    }\n  }\n\n  &-mobile-active {\n    color: @primary-90;\n    font-size: 18px;\n    font-weight: bold;\n    text-decoration: underline;\n  }\n}\n "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
